import React from 'react';
import {connect} from "react-redux";
import {Button, Col, Form, Row, Radio, Space, Typography, Card} from "antd";
import language from "../../languages/language";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import getTemplates from "../../actions/getTemplates";
import isLoggedIn from "../../actions/isLoggedIn";

class Orders extends React.Component
{
    componentDidMount()
    {
        this.props.isLoggedIn();
    }

    getTemplates=(formValues)=>
    {
        const order=this.props.info.orders.filter((order)=>order.id===formValues.order)[0];
        formValues.mail=order.mail;
        formValues.order=order.id;
        this.props.getTemplates({...this.props.info,...formValues});
    };

    render()
    {
        const span=24;
        return <Card title={language[this.props.language].advSentToMenu} bordered={false}>
            <TitleAndInfo info={language[this.props.language].advTitleIDLabel}/>
            <Form ref={this.formRef} onFinish={this.getTemplates} className={'regularForm'}>
                <Row justify={'center'}>
                    <Typography>{language[this.props.language].advOrdersLabel}</Typography>
                </Row>
                <Row justify={'center'} style={{marginBottom:10}}/>
                <Row justify={'center'}>
                        <Form.Item name="order"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Radio.Group>
                                <Space direction="vertical">
                                    {this.props.info && this.props.info.orders?this.props.info.orders.map((order)=><Radio value={order.id}>{' ' +order.id}</Radio>):<></>}
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                </Row>
                <Row justify={'center'} style={{marginBottom:20}}/>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item className={'text-center'}>
                            <Button type="primary light-blue rounded" htmlType="submit">
                                {language[this.props.language].advOrdersButtonLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        info:state.info
    }
}
export default connect(mapStateToProps, {getTemplates,isLoggedIn})(Orders);